package diana.soleil.design.iraniancanadienbazzar.locale

import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidedValue
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.text.intl.Locale
import kotlinx.browser.document

/** `window.__customLocale` is read by the `navigator.languages` shim in `webApp` index.html. */
private external object window {
    var __customLocale: String?
}

/** Base language codes that lay out right-to-left (the app only ships `fa`; the rest are future-proofing). */
private val RtlLanguages = setOf("fa", "ar", "he", "ur")

actual object LocalAppLocale {
    private val LocalAppLocale = staticCompositionLocalOf { Locale.current }

    actual val current: String
        @Composable get() = LocalAppLocale.current.toString()

    @Composable
    actual infix fun provides(value: String?): ProvidedValue<*> {
        val normalized = value?.replace('_', '-')
        window.__customLocale = normalized
        // Keep the HTML document's language/direction in sync with the in-app locale. Compose only
        // sets direction inside its own canvas, so without this the document stays `lang="en"` with no
        // `dir` even in Farsi — misleading screen readers, the browser, and search engines.
        if (normalized != null) {
            val rtl = normalized.substringBefore('-').lowercase() in RtlLanguages
            document.documentElement?.apply {
                setAttribute("lang", normalized)
                setAttribute("dir", if (rtl) "rtl" else "ltr")
            }
        }
        return LocalAppLocale.provides(Locale.current)
    }
}
